import { useAction } from "./useAction";
import { Cota } from "../interfaces/Cota";
import { cadastrarCotaService } from "../services/cadastrarCotaService";

export const useCadastrarCota = () => {
  const {
    execute: cadastrarCota,
    isLoading,
    data,
    error,
    success,
  } = useAction<Cota>(cadastrarCotaService);

  const handleSubmit = async (cota: Cota) => {
    try {
      const response = await cadastrarCota(cota);
      console.log("Cota cadastrada com sucesso", response);
      return response;
    } catch (error) {
      console.error("Erro ao cadastrar cota", error);
      throw error; // propaga erro para quem chamou
    }
  };

  return {
    handleSubmit,
    isLoading,
    data,
    error,
    success,
  };
};
